<button
    [nzTooltipTrigger]="isDisabled ? 'hover' : null"
    nzTooltipTitle="{{tooltip}}"
    nzTooltipPlacement="top"
    nz-tooltip
    nz-button
    class="{{className}} {{ isDisabled ? 'disabled-button': ''}}"
    nzSize="{{size}}"
    (click)="isDisabled ? '' : clickBtn()"
>
    {{buttonText}}
</button>
